import Vue from 'vue';

function authRequest() {
    return Vue.prototype.$authService.renewAuthInfo();
}


const unauthorizedHandler = (response) => {
    if(response.status === 403){
        let message = response.data && response.data.message ? response.data.message : "Authentication error";
        Vue.prototype.$authService.logoutWithError(message);
        return Promise.reject(response);
    }
    return Promise.resolve(response);
};

export default {
    jwt: function(to, from){
        return authRequest().then((response) => unauthorizedHandler(response, from, to));
    },
    redirectIfAuth: function (to, from) {
        return new Promise((resolve, reject) => {
            authRequest().then((response) => {
                response.status === 200 ? reject() : resolve(true);
            }).catch(() =>{
                resolve(true);
            });
        });
    },
    redirects: {
        jwt: '/auth',
        redirectIfAuth: '/'
    }
}


// WEBPACK FOOTER //
// ./src/router/middlewares.js